import { Component,OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { RolegaurdService } from './Data Service/rolegaurd.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import {filter} from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as moment from 'moment';
import { NewVulnerabilityService } from './Data Service/new-vulnerability.service';
import { DialogueConfirmationComponent,ConfirmDialogModel } from './Dialogue Confirmation/dialogue-confirmation/dialogue-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { data } from 'jquery';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})

export class AppComponent implements OnInit {
  title = 'VulnerabilityPortal';
  isIframe = false;
  loginDisplay = false;

  navLinks: any[];
  activeLinkIndex = -1; 
  
//_refreshNeeded = false;
_ngCallCount = 0;
 userNameData = "";
 EIDApp = "";
 isShown: boolean = true ;
 userInfo = new BehaviorSubject(null);
 jwtHelper = new JwtHelperService();
 gccUser = false;
 verifyUser = false;
 isAdmin = false;
  
  constructor(private router: Router,private authService: MsalService,private _roleGaurd : RolegaurdService
    ,private actroute : ActivatedRoute,private service : NewVulnerabilityService) {}
ngOnInit(): void {
  
// console.log(this.actroute.url.subscribe(url => console.log(url[0].path)));
// console.log(this.router.url);
// console.log("window loc ");
// console.log(window.location.pathname);
// console.log("pipe url :");
//   this.router.events.pipe(
//     filter(event => event instanceof NavigationEnd)
// )
//     .subscribe(event => {
//         console.log((<NavigationEnd>event).url);
//     });

    
  this.authService.instance.handleRedirectPromise().then( res => {
    console.log("comp res : "+res);
    if (res != null && res.account != null) {
      //console.log("already logged in");
      this.userNameData = res.account.username;
      if(this.EIDApp == "" || this.EIDApp == null){
        
        this.EIDApp = res.account.username;
      }
      console.log("EID App "+this.EIDApp.lastIndexOf("@"));
      
      if ("UserID" in localStorage) {
    } else {
      localStorage.setItem('UserID',this.EIDApp);
    }
      console.log("EIDApp :" +this.EIDApp);
      this.authService.instance.setActiveAccount(res.account);
      console.log("res account : "+res.account.username);
      console.log("uniqueId : "+res.account.idTokenClaims);
      console.log("idToken : "+res.idToken);
      console.log("res accessToken : "+res.accessToken);
      console.log("auth roles : "+ this.authService.instance.getAccountByUsername(this.userNameData));
      console.log("role serve : " +this._roleGaurd.getRoles())
      console.log("app comp admin call ");
      console.log(this.appAdmin());
      //Response.redirect("http://localhost:4200");
      const tokenData = this.userLogin(res.idToken);
      console.log("tokenData" + tokenData);

      if(tokenData)
      {
        let verEID = "";
        let userID = localStorage.getItem('UserID').substring(0, localStorage.getItem('UserID').lastIndexOf("@"));
        this.service.verifyContEidAsPromise(userID).then(
          (data) => {
            verEID = data;
            if (verEID != "") {
              if (verEID == "Ok") {
                this.verifyUser = true;
              }
              else {
                this.verifyUser = false;
              }
            }
            // this.gccUser = this.appUserDLDetails();
            this.chkUserDLDetails();

          }
        ).catch((error => {
          console.log("Promise rejected with " + JSON.stringify(error));
        }));

        /*
          //alert(tokenData);
          if (this.appAdmin() && window.location.pathname === '/' && this.appUser()) {
            console.log("admin");
            this.router.navigate(['/home'])
          }

          if (!this.appAdmin() && window.location.pathname === '/' && this.appUser()) {
            console.log("user");
            this.router.navigate(['/UserView'])
          }

          if (this.appAdmin() && window.location.pathname === '/' && !this.appUser()) {
            console.log("admin");
            this.router.navigate(['/home'])
          }
           **/     
      }
      else{
        alert("Token expired.");
        this.authService.loginRedirect();
      }
    }
    else{
      console.log("login");
      this.authService.loginRedirect();
    }
  })
  

  //gccUser = this.getUserDLDetails();
  let verEID = "";
   //below should be used for dev
  // this.verifyUser= true;
  // this.gccUser = true;
  // this.isAdmin = true;
  // this.router.navigate(['/home']);

  /**  for dev
  this.service.verifyContEidAsPromise("sharad.singh.singh").then(
    (data) =>{
      verEID = data;
      // if(verEID != ""){
      //   if(verEID == "Ok")
      //   {
      //     this.verifyUser= true;  
      //   }
      //   else{
      //     this.verifyUser= false;
      //   }
      // }
      this.verifyUser = verEID == "Ok" ? true : false;

      // this.gccUser = this.appUserDLDetails();
      this.chkUserDLDetails();
      
    }
  ).catch((error => {
    console.log("Promise rejected with " + JSON.stringify(error));
  }));
*/

  // this.service.verifyContEid(
  //   "robert.wardle"
  // ).subscribe(res => {
  //   verEID = res.toString();

  //   // if(verEID != ""){
  //   //   if(verEID == "Ok")
  //   //   {
  //   //    boolValue= true;  
  //   //   }
  //   //   else{
  //   //     boolValue= false;
  //   //   }
  //   // }
  // });

  

   // verifyUser = this.appVerifyContEID();
  /*
  setTimeout(() => {
  // gccUser = this.appUserDLDetails();
  if (this.appUserDLDetails()) {
    if (this.appAdmin() && window.location.pathname === '/' && this.appUser()) {
      console.log("admin");
      this.router.navigate(['/home'])
    }

    if (!this.appAdmin() && window.location.pathname === '/' && this.appUser()) {
      console.log("user");
      this.router.navigate(['/UserView'])
    }

    if (this.appAdmin() && window.location.pathname === '/' && !this.appUser()) {
      console.log("admin");
      this.router.navigate(['/home'])
    }
  }
  else{
    if(verifyUser){
      this.router.navigate(['/UserView']);
    }
    else{
      alert("You don't have access to this page. Kindly contact administrator.");
    }
  }
}, 10000);
**/
}

userAccess(){
  this.isAdmin = this.appAdmin();
  if (this.gccUser) {
    // this.router.navigate(['/home'])     

    if (window.location.pathname === '/home' || window.location.pathname === '/') {
      console.log("home");
      this.router.navigate(['/home'])
    }
    else if (window.location.pathname === '/UserView') {
      console.log("user");
      this.router.navigate(['/UserView'])
    }
    else{
      this.router.navigate([this.router.url]);
    }

    // if (this.appAdmin() && window.location.pathname === '/' && this.appUser()) {
    //   console.log("admin");
    //   this.router.navigate(['/home'])
    // }

    // if (!this.appAdmin() && window.location.pathname === '/' && this.appUser()) {
    //   console.log("user");
    //   this.router.navigate(['/UserView'])
    // }

    // if (this.appAdmin() && window.location.pathname === '/' && !this.appUser()) {
    //   console.log("admin");
    //   this.router.navigate(['/home'])
    // }
  }
  else{
    if(this.verifyUser){
      this.router.navigate(['/UserView']);
    }
    else{
      // alert("You don't have access to this page. Kindly contact administrator.");  
      this.router.navigate(['/LoginError']);    
    }
  }
}

userLogin(idTokendata : any): boolean{
  if(!idTokendata){
    return false;
  }
  console.log("into userLogin");
  localStorage.setItem("access_token", idTokendata);
  const decodedUser = this.jwtHelper.decodeToken(idTokendata);
  console.log("decodeUser ");
  
  localStorage.setItem("expTime",decodedUser.exp);
  console.log(moment(decodedUser.exp));
  localStorage.setItem("Decode",decodedUser);
  const expTimeing = moment(decodedUser.exp);
  localStorage.setItem("expireTime",expTimeing.toString());
  const momUnix = moment().unix();
  localStorage.setItem("momentUnix",momUnix.toString());
  localStorage.setItem("payload",decodedUser.Payload);
  localStorage.setItem("claims",decodedUser.claims);
  this.userInfo.next(decodedUser);

  let userData = this.userInfo.getValue();
  localStorage.setItem("userData",userData[0]);
  localStorage.setItem("userDataName",userData.preferred_username);
  if(decodedUser.exp <= moment().unix() && userData.preferred_username != this.EIDApp){
    return false;
  }
  else{
    return true;
  }
  
}

toggleShow() {

  this.isShown = ! this.isShown;
  
  }

isLoggedIn(): boolean {
  //console.log("isLoggedIN called : ");
  //console.log("getActiveAccount : "+this.authService.instance.getActiveAccount());
  return this.authService.instance.getActiveAccount() != null
}

login() {
  this.authService.loginRedirect();
}

setLoginDisplay() {
  this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
}

logout() {
  this.authService.logout();
}

appUser() : boolean{
  const isUser = this._roleGaurd.appUser();
  //console.log("user bool HG : "+isUser);
  return isUser;
}
appAdmin() : boolean{
  const isAdmin = this._roleGaurd.appAdmin();
  //console.log("admin bool HG : "+isAdmin);
  return isAdmin;
}

appUserDLDetails() : boolean{
  let isGccUser;
  try{
    isGccUser = this._roleGaurd.getUserDLDetails();
    console.log("isGccuser "+isGccUser);
  }
  catch(err){
    console.log("in error");
    console.log(err);
  }
  
  return isGccUser;
}

  chkUserDLDetails() {
    let resultData = "";
    let bValue = false;
    // localStorage.setItem('UserID', 'sharad.singh.singh@accenture.com');

    //await 
    this.service.userDLDetailsAsPromise(
      localStorage.getItem('UserID').substring(0, localStorage.getItem('UserID').lastIndexOf("@"))
    ).then
      ((res: any) => {
        resultData = res;

        // if (resultData != "") {
        //   if (resultData == "FromGCC") {
        //     bValue = true;
        //     this.gccUser = true;
        //   }
        //   else {
        //     bValue = false;
        //     this.gccUser = false;
        //   }

        // }
        this.gccUser = resultData == "FromGCC" ? true : false;
        this.userAccess();
      }, (error: any) => {
        //  this.errormessage = error;
        alert(error + " cust");
        console.log("er msg " + error.message);
      });

      
    //  console.log("resultData "+resultData);
    //  return bValue;
  }

appVerifyContEID() : boolean{
  let isVerified;
  try{
    isVerified = this._roleGaurd.verifyUserID();
  console.log("verify cont "+isVerified);
  } 
  catch(err){
    console.log("in error");
    console.log(err);
  }
  
  return isVerified;
}

onReportClick() {
  let rptLink;
  this.service.getReportLink().subscribe(
    (data :any)=>{
      rptLink = data.Value;
      (window as any).open(rptLink, "_blank");
    }
  );
  console.log("link "+rptLink);
}

}
